import "angular";
import LogDecorator from "./LogDecorator";

var moduleName = "LoggerModule";
var moduleDependencies = [];

const LoggerModule = angular.module(moduleName, moduleDependencies).config(LogDecorator);

export default LoggerModule;
